export const distinct = (value: any, index: number, self: any[]) =>
  self.indexOf(value) === index;
